import { Component } from 'opus-angular-seed-core';
import { MAX_FILE_SIZE_BYTES, formatFileSizeMb } from '../fileConstants';
import { trashIcon, downloadIcon } from '../fileIcon';
@Component({
    bindings: {
        resolve: '<',
        modalInstance: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'file.Files' | translate }}</h2>
        </div>
        <style>
            .file-library-modal .table-tools label {
                display: flex;
                align-items: center;
                gap: .5em;
                white-space: nowrap;
            }
            .file-library-modal__row--disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            .file-library-modal__row--disabled input[type="checkbox"] {
                pointer-events: none;
            }
            .file-library-modal__table {
                table-layout: fixed;
                width: 100%;
            }
            .file-library-modal__name {
                display: flex;
                align-items: center;
                min-width: 0;
            }
            .file-library-modal__name-text {
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;
            }
        </style>
        <div class="modal-body file-library-modal">
            <div class="form form-filter inline">
                <div class="search02">
                    <input type="text" placeholder="{{ 'file.Filename' | translate }}" ng-model="vm.searchQuery">
                </div>
                <ul class="actions01">
                    <li><input type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}" ng-click="vm.resetFilter()"></li>
                    <li><input type="submit" class="btn main" ng-click="vm.applyFilter()" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
            <div class="well">
                <pagination-tools list="vm.list"></pagination-tools>
                <table class="data01 file-library-modal__table">
                    <colgroup>
                        <col width="40px"/>
                        <col width="45%"/>
                        <col width="20%"/>
                        <col/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th class="w1p">&nbsp;</th>
                        <th>{{ 'file.Name' | translate }}</th>
                        <th>{{ 'file.Date uploaded' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="file in vm.list.items"
                        ng-class="{'file-library-modal__row--disabled': vm.isFileAlreadyAttached(file)}"
                        title="{{ vm.isFileAlreadyAttached(file) ? ('file.This file is already added' | translate) : '' }}">
                        <td class="w1p">
                            <input ng-checked="vm.isFileSelected(file)"
                                ng-click="vm.toggleFileSelection(file)"
                                ng-disabled="vm.isFileAlreadyAttached(file)"
                                type="checkbox">
                        </td>
                        <td>
                            <div class="file-library-modal__name">
                                <file-file-icon filename="file.filename"></file-file-icon>
                                <span class="file-library-modal__name-text" title="{{ file.filename }}">{{ file.filename }}</span>
                            </div>
                        </td>
                        <td>{{ vm.formatDate(file.createdAt) }}</td>
                        <td class="actions">
                            <a ng-click="vm.downloadFile(file.hash)" class="btn">
                                <span class="file-icon file-icon--sm" ng-bind-html="vm.downloadIconHtml"></span>
                                {{ 'general.Download' | translate }}
                            </a>
                            <a ng-click="vm.confirmDeleteFile(file)" class="btn"><span class="file-icon file-icon--sm" ng-bind-html="vm.trashIconHtml"></span> {{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
            <ul class="actions01">
                <li class="fileupload">
                    <input type="file" ngf-select="vm.uploadInModal($files)" ngf-multiple="true" multiple/>
                    <a class="btn bordered02 small">{{ 'file.Upload material' | translate }}</a>
                </li>
            </ul>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.attachSelected()" ng-disabled="!vm.selectedFileHashes.length">{{ 'file.Use selected files' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (FileService, AuthResource, MomentService, ModalService, $window, $q, toastr, $translate, $sce, $timeout) {
        this.FileService = FileService;
        this.$timeout = $timeout;
        this.trashIconHtml = $sce.trustAsHtml(trashIcon);
        this.downloadIconHtml = $sce.trustAsHtml(downloadIcon);
        this.AuthResource = AuthResource;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.$window = $window;
        this.$q = $q;
        this.toastr = toastr;
        this.$translate = $translate;
        this.files = [];
        this.filteredFiles = [];
        this.searchQuery = '';
        this.selectedFileHashes = [];
        this.entityFileHashes = {};
        this.list = this._createClientList();
    }
    $onInit () {
        this.entityType = this.resolve.entityType;
        this.entityId = this.resolve.entityId;
        this.courseId = this.resolve.courseId;
        this.loadEntityFiles();
        this.loadFiles();
    }
    loadEntityFiles () {
        if (!this.entityType || !this.entityId) {
            return;
        }
        this.FileService.getEntityFiles(this.entityType, this.entityId).then((files) => {
            this.entityFileHashes = {};
            files.forEach((file) => {
                this.entityFileHashes[file.fileHash] = true;
            });
        });
    }
    isFileAlreadyAttached (file) {
        return !!this.entityFileHashes[file.hash];
    }
    loadFiles () {
        const listEntityType = this.courseId ? 'course' : null;
        const listEntityId = this.courseId || null;
        this.FileService.listFiles(listEntityType, listEntityId).then((files) => {
            this.files = files;
            this.applyFilter();
        });
    }
    _createClientList () {
        const self = this;
        const list = {
            items: [],
            loading: false,
            lastQuery: {},
            lastPostParameters: {},
            sort: undefined,
            pagination: {
                currentPage: 1,
                perPage: 25,
                pageCount: 1,
                totalCount: 0
            },
            fetch: () => {
                list.loading = true;
                self.$timeout(() => {
                    const page = list.pagination.currentPage;
                    const perPage = list.lastQuery.pageSize || list.pagination.perPage;
                    list.pagination.perPage = perPage;
                    list.pagination.totalCount = self.filteredFiles.length;
                    list.pagination.pageCount = Math.max(1, Math.ceil(self.filteredFiles.length / perPage));
                    if (page > list.pagination.pageCount) {
                        list.pagination.currentPage = list.pagination.pageCount;
                    }
                    const start = (list.pagination.currentPage - 1) * perPage;
                    list.items = self.filteredFiles.slice(start, start + perPage);
                    list.loading = false;
                });
            }
        };
        return list;
    }
    applyFilter () {
        const query = this.searchQuery.toLowerCase();
        if (!query) {
            this.filteredFiles = this.files.slice();
        }
        else {
            this.filteredFiles = this.files.filter(
                file => file.filename.toLowerCase().indexOf(query) !== -1
            );
        }
        this.list.pagination.currentPage = 1;
        this.list.fetch();
    }
    resetFilter () {
        this.searchQuery = '';
        this.applyFilter();
    }
    uploadInModal (files) {
        if (!files || !files.length) {
            return;
        }
        const attachEntityType = this.courseId ? 'course' : this.entityType;
        const attachEntityId = this.courseId || this.entityId;
        const attachToEntities = [{ entityType: attachEntityType, entityId: attachEntityId }];
        const acceptedFiles = files.filter(file => {
            if (file.size > MAX_FILE_SIZE_BYTES) {
                const message = this.$translate.instant('file.File exceeds the maximum allowed size');
                this.toastr.error(`${message} (${formatFileSizeMb(MAX_FILE_SIZE_BYTES)}): ${file.name}`);
                return false;
            }
            return true;
        });
        if (!acceptedFiles.length) {
            return;
        }
        const uploadPromises = acceptedFiles.map(file => {
            return this.FileService.upload(file, attachToEntities).then(() => {
                this.toastr.success(this.$translate.instant('file.File uploaded successfully'));
            }).catch((error) => {
                let message = this.$translate.instant('file.Upload failed');
                if (error && error.data) {
                    if (Array.isArray(error.data) && error.data.length && error.data[0].message) {
                        message = error.data[0].message;
                    }
                    else if (error.data.message) {
                        message = error.data.message;
                    }
                }
                this.toastr.error(`${message}: ${file.name}`);
            });
        });
        this.$q.all(uploadPromises).then(() => {
            this.loadFiles();
        });
    }
    isFileSelected (file) {
        return this.selectedFileHashes.indexOf(file.hash) !== -1;
    }
    toggleFileSelection (file) {
        if (this.isFileAlreadyAttached(file)) {
            return;
        }
        const index = this.selectedFileHashes.indexOf(file.hash);
        if (index === -1) {
            this.selectedFileHashes.push(file.hash);
        }
        else {
            this.selectedFileHashes.splice(index, 1);
        }
    }
    attachSelected () {
        if (!this.selectedFileHashes.length) {
            return;
        }
        const attachPromises = this.selectedFileHashes.map((fileHash) => {
            return this.FileService.attach(fileHash, this.entityType, this.entityId).then(() => {
                return { fileHash, success: true };
            }).catch((error) => {
                let message = this.$translate.instant('file.Failed to attach file');
                if (error && error.data) {
                    if (Array.isArray(error.data) && error.data.length && error.data[0].message) {
                        message = error.data[0].message;
                    }
                    else if (error.data.message) {
                        message = error.data.message;
                    }
                }
                this.toastr.error(message);
                return { fileHash, success: false };
            });
        });
        this.$q.all(attachPromises).then((results) => {
            const attached = results.filter(result => result.success).map(result => result.fileHash);
            if (attached.length) {
                this.toastr.success(this.$translate.instant('file.File attached successfully'));
                this.modalInstance.close(attached);
            }
        });
    }
    confirmDeleteFile (file) {
        const message = this.$translate.instant(
            'file.delete_confirmation_message'
        );
        const detachEntityType = this.courseId ? 'course' : this.entityType;
        const detachEntityId = this.courseId || this.entityId;
        const detachFromEntities = detachEntityType && detachEntityId
            ? [{ entityType: detachEntityType, entityId: detachEntityId }]
            : [];
        this.ModalService.delete(message).then(() => {
            this.FileService.deleteFile(file.hash, detachFromEntities).then(() => {
                this.toastr.success(this.$translate.instant('file.File deleted successfully'));
                const index = this.files.indexOf(file);
                if (index > -1) {
                    this.files.splice(index, 1);
                }
                const selectedIndex = this.selectedFileHashes.indexOf(file.hash);
                if (selectedIndex > -1) {
                    this.selectedFileHashes.splice(selectedIndex, 1);
                }
                this.applyFilter();
            }).catch(() => {
                this.toastr.error(this.$translate.instant('file.Failed to delete file'));
            });
        });
    }
    downloadFile (fileHash) {
        this.AuthResource
            .requestTacToken().$promise
            .then((response) => {
                const url = `${this.FileService.getDownloadUrl(fileHash)}?tacToken=${response.token}`;
                this.$window.open(url);
            });
    }
    formatDate (datetime) {
        return this.MomentService.format(datetime, 'DD.MM.YYYY');
    }
    cancel () {
        this.modalInstance.dismiss('cancel');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/file/fileLibraryModal/index.js